export default __webpack_public_path__ + "static/media/insight-notification.33140625.svg";